<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Medicamento</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Receitar Medicamento
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">{{ item.nome }}</td>
                                    <td
                                        :data-label="headers[2].name"
                                    >{{ item.dataAplicacao | formatDate('DD/MM/YYYY HH:mm:ss ') }}</td>
                                    <td
                                        :data-label="headers[3].name"
                                    >{{ item.viaAdministracao.nome}}</td>

                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="far fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../../facade/facade";
import Select2 from "../../../components/Input/Select2";

const facade = new Facade();

export default {
    components: { Select2 },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Data", key: "data_aplicacao" },
                { name: "Via de Administração", key: "nome" }
            ],
            filter: {
                nome: ""
            },
            list: {},
            size: 20,
            page: 0,
            order: ["id", "ASC"]
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        create() {
            this.$router.push({ name: "new-medicine-pet" });
        },
        back() {
            this.$router.push({
                name: "list-pet",
                params: {
                    idCliente: this.$route.params.idCliente
                }
            });
        },
        edit(id) {
            this.$router.push({
                name: "edit-medicine-pet",
                params: {
                    idCliente: this.$route.params.idCliente,
                    id: this.$route.params.id,
                    idMedicine: id
                }
            });
        },
        async remove(id) {
            try {
                await this.$swal({
                    title: "Você tem certeza?",
                    text: "Não será possível reverter esta operação",
                    showCancelButton: true,
                    confirmButtonText: "Sim, deletar!",
                    cancelButtonText: "Não, cancelar!"
                });
                this.$loading.show(true);
                let ret = await facade.deleteMedicine(id);
                this.$notify.success("", "Registro removido com sucesso.");
                this.fetchData(0);
                this.$loading.show(false);
            } catch (e) {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao deletar a Medicamento."
                );
                this.$loading.show(false);
            }
        },
        clean() {
            this.filter = {};
        },

        async fetchData(page) {
            try {
                let vm = this;
                vm.page = page;

                let params = {
                    params: {
                        page: vm.page,
                        size: vm.size,
                        order: vm.order,
                        idPet: vm.$route.params.id,
                        nome: vm.filter.nome
                    }
                };
                for (let key in this.filter) {
                    if (this.filter.hasOwnProperty(key)) {
                        params["params"][key] = this.filter[key];
                    }
                }
                let ret = await facade.listMedicine(params);
                vm.list = ret.data.data;
                this.$loading.show(false);
            } catch (e) {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar os medicamentos."
                );
                this.$loading.show(false);
            }
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?ca5f3020